import React from 'react'

export default function Tags({ tags }) {
    return tags.map((tag) => (
        <div className="mr-4 py-4" key={tag.id}>
            <h3 className="text-md px-2 py-2 rounded-md button text-gray-700">#{tag.name}</h3>
        </div>
    ))
}
